import { Container } from 'styles/global'
import { Detail } from '../detail'
import { ProjectIntro } from '../projectintro'
import { useLanguage } from 'languages/language'

const CTCatalogue = () => {
  const { texts } = useLanguage()
  return (
    <Container>
      <ProjectIntro project={texts.soldierswhodiedinukraine} />
      <Detail
        dir="left"
        media={texts.soldierswhodiedinukraine.imgs[0]}
        text={texts.soldierswhodiedinukraine.texts[0]}
      />
      <Detail
        dir="right"
        media={texts.soldierswhodiedinukraine.imgs[1]}
        text={texts.soldierswhodiedinukraine.texts[1]}
      />
      <Detail
        dir="left"
        media={texts.soldierswhodiedinukraine.imgs[2]}
        text={texts.soldierswhodiedinukraine.texts[2]}
      />
      <Detail
        dir="right"
        media={texts.soldierswhodiedinukraine.imgs[3]}
        text={texts.soldierswhodiedinukraine.texts[3]}
      />
      <Detail
        dir="left"
        media={texts.soldierswhodiedinukraine.imgs[4]}
        text={texts.soldierswhodiedinukraine.texts[4]}
      />
    </Container>
  )
}
export default CTCatalogue
